import { featureItems } from '@/mocks/homeData';

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            平台优势
          </h2>
          <div className="mt-4 w-16 h-1 bg-primary-500 mx-auto rounded-full"></div>
          <p className="mt-3 text-sm text-foreground-600">为什么选择51吃瓜网站</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {featureItems.map((item, i) => (
            <div
              key={i}
              className="group p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 cursor-pointer text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto rounded-2xl bg-primary-100/70 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${item.icon} text-primary-500 text-xl md:text-2xl group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="mt-4 text-sm md:text-base font-semibold text-foreground-900 font-heading">
                {item.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}